import React from 'react';
import styles from './Products.module.css';
import {REACT_APP_EMR_COMPONENT_HANDLE, REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE} from "../../../../env";

const emrOptions = [
  { value: 'no', label: 'No'},
  { value: 'athena', label: 'Athena'},
];

const Products = ({ selectedAddOns, emrChoice, onEmrChange, addOns, onAddOnSelectionChange }) => {
  const emrProductHandle = REACT_APP_EMR_COMPONENT_HANDLE;
  const onCallProductHandle = REACT_APP_ON_CALL_PROVIDERS_COMPONENT_HANDLE;

  const onCallAddOn = selectedAddOns.find(a => a.handle === onCallProductHandle);
  const emrAddOn = addOns.find(a => a.handle === emrProductHandle);

  const standardAddOns = addOns.filter(a => a.handle !== emrProductHandle && a.handle !== onCallProductHandle);

  return (
    <>
      <h2 className={styles.stepTitle}>Select Add-Ons</h2>
      {onCallAddOn && (
        <div className={styles.selectionBlock}>
          <h3 className={styles.selectionBlockQuestion}>{onCallAddOn.quantity} On-Call Provider{onCallAddOn.quantity > 1 ? 's' : ''}</h3>
          <div className={styles.selectionBlockSubtext}>
            On-call providers who are part of this subscription
          </div>
        </div>
      )}

      {emrAddOn && (
        <div className={styles.selectionBlock}>
          <label htmlFor="emr-select" className={styles.selectionBlockQuestion}>
            Would you like to integrate with one of the EMR Providers below?
          </label>
          <div className={styles.selectionBlockSubtext}>
            {emrAddOn.description}
          </div>
          <select
            id="emr-select"
            value={emrChoice}
            onChange={onEmrChange}
            className={styles.emrPicklist}
          >
            {emrOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {standardAddOns.map(addOn => {
        const isSelected = selectedAddOns.some(p => p.id === addOn.id);
        return (
          <div key={addOn.id} className={styles.selectionBlock}>
            <label className={styles.selectionBlockQuestion}>
              Would you like to add {addOn.name}?
            </label>
            <div className={styles.selectionBlockSubtext}>
              {addOn.description}
            </div>
            <div className={styles.selectionBlockOptions}>
              <div className={styles.selectionBlockOption}>
                <label>
                  <input
                    type="radio"
                    name={addOn.handle}
                    value="yes"
                    checked={isSelected}
                    onChange={() => onAddOnSelectionChange(addOn, true)}
                  />
                  Yes
                </label>
              </div>
              <div className={styles.selectionBlockOption}>
                <label>
                  <input
                    type="radio"
                    name={addOn.handle}
                    value="no"
                    checked={!isSelected}
                    onChange={() => onAddOnSelectionChange(addOn, false)}
                  />
                  No
                </label>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Products;
